import { Redirect } from "react-router-dom"

import { TaskManagementView } from "src/components/TaskManagement/TaskManagementView"
import { useFeatureAvailability } from "src/data/featureAvailability/logic/useFeatureAvailability"
import { useBackendFlags } from "src/data/flags/useBackendFlags"
import { Routes } from "src/router/routes"

export function TaskManagement() {
  const { available: taskManagementAvailable } = useFeatureAvailability({
    feature: "task_management",
  })

  const { task_management_released } = useBackendFlags()

  if (!taskManagementAvailable) {
    return <Redirect to={Routes.Dashboard.location().pathname} />
  }

  if (!task_management_released) {
    return <Redirect to={Routes.TaskManagementBetaStart.location().pathname} />
  }

  return <TaskManagementView />
}
